import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppEmbadedSoftComponent } from './app-embaded-soft/app-embaded-soft.component';

const routes: Routes = [
  {
    path: '',
    children: [
        {
            path: 'embaded-soft',
            component: AppEmbadedSoftComponent,
            data: {
                title: 'Embaded Soft page'
            }
        }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentPagesRoutingModule { }
